import React, { FunctionComponent } from 'react';
import { Box } from '@material-ui/core';
import { useCommonStyles } from '../CommonStyles';
import { TextField2 } from 'components/UI';
import clsx from 'clsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/pro-light-svg-icons';

interface SearchInputProps {
    searchText: string;
    setSearchText: (text: string) => void;
    showSearch: boolean;
    handleClickSearch: () => void;
}

const SearchInput: FunctionComponent<SearchInputProps> = ({
    searchText,
    setSearchText,
    showSearch,
    handleClickSearch
}) => {
    const commonClasses = useCommonStyles();

    const searchIcon = (
        <FontAwesomeIcon
            onClick={handleClickSearch}
            icon={faSearch}
            className={clsx(!showSearch ? commonClasses.iconSearch : commonClasses.search)}
        />
    );

    return (
        <Box className={clsx(commonClasses.containerSearch)}>
            <Box className={clsx(commonClasses.inputContainer)}>
                <Box className={clsx(commonClasses.inputBox)}>
                    <TextField2
                        id="bookings_insights_search_by_title_input"
                        placeholder="Search by insight name"
                        className={commonClasses.input}
                        value={searchText}
                        onChange={setSearchText}
                        startIcon={searchIcon}
                    />
                </Box>
            </Box>
        </Box>
    );
};

export default SearchInput;
